import { Component, OnInit, OnDestroy, EventEmitter, Output, ViewChild, AfterViewChecked, ViewChildren, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { SubscriptionList } from '../../shared/models/asp.types';
import * as fromActions from '../../store/delivery-checklist/delivery-checklist.actions';
import * as fromSelectors from '../../store/delivery-checklist/delivery-checklist.selectors';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { IDigitalChecklistAppointment } from '@signal/asp-data-commons';
import { ActivatedRoute, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';
import { DigitalChecklistStatus, SortOrder } from '@signal/asp-data-commons/lib/enums/enum';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import _ from 'lodash';
import { getSessionTable, setSessionTable, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { DeliveryChecklistState } from '../../store/delivery-checklist/delivery-checklist.reducer';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { DeliveryChecklistService } from '../../shared/services/delivery-checklist.service';
import { AlertService } from '../../shared/services/alert.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Clipboard } from '@angular/cdk/clipboard';
import {TranslateService} from '@ngx-translate/core';
import { ServiceAppointmentState } from '../../store/service-appointment/service-appointment.reducer';
import { selectNotificationDashboardData } from '../../store/service-appointment/service-appointment.selectors';
import { AppSyncService } from '../../shared/services/appsync.service';
import { PageEvent } from '@angular/material/paginator';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-checklist-summary',
  templateUrl: './checklist-summary.component.html',
  styleUrls: ['./checklist-summary.component.scss']
})
export class ChecklistSummaryComponent implements OnInit, OnDestroy,AfterViewChecked{
  isLoading$: Observable<boolean>;

  initColumns: any[] = [{ id: 'customerName', display: 'pendingAppointments.customerName',minWidth:152,maxWidth:320 }, { id: 'contactInfo', display: 'pendingAppointments.customerContactInformation',minWidth:184,maxWidth:380 },
  { id: 'model', display: 'pendingAppointments.vehicleModel', col: 'model' ,minWidth:177,maxWidth:260 }, 
  { id: 'vin', display: 'VIN', col: 'vin',minWidth:120,maxWidth:200},
  { id: 'vehicleStatus', display: 'pendingAppointments.vehicleStatus', col: 'dealerCategory', minWidth:60,maxWidth:120 },
  {id: 'advisor', display: 'navigation.salesAdvisor', col: 'salesConsultant',minWidth:120,maxWidth:195},
  { id: 'deliveryDate', display: 'deliveryChecklist.deliveryDate', col: 'dateOfAcquired',minWidth:100,maxWidth:140 },
  { id: 'deliveryTime', display: 'deliveryChecklist.deliveryTime', col: 'scheduledTime', minWidth:60, maxWidth:120 }, { id: 'status', display: 'opcodeServiceManagement.status', col: 'status' ,minWidth:95,maxWidth:130}];

  columnsToDisplay = ['actions', 'select', 'customerName', 'contactInfo', 'model', 'vin', 'vehicleStatus', 'advisor',
    'deliveryDate', 'deliveryTime', 'status'];
  columnsToDisplayForFilter: any[] = ['actionsFilter', 'selectFilter', 'customerNameFilter', 'contactInfoFilter', 'modelFilter',
    'vinFilter', 'vehicleStatusFilter', 'salesConsultantFilter','deliveryDateFilter', 'deliveryTimeFilter', 'statusFilter'];

  initColumnsForFilter: any[] = [{id:'actionsFilter', display: '' }, {id:'selectFilter', display :''}, {id :'customerNameFilter', display : 'pendingAppointments.customerName'},
  {id:'contactInfoFilter', display: 'pendingAppointments.customerContactInformation'},{id:'modelFilter', display: 'pendingAppointments.vehicleModel'},
  {id:'vinFilter', display: 'VIN'}, {id:'vehicleStatusFilter', display: 'pendingAppointments.vehicleStatus'}, {id: 'salesConsultantFilter', display: 'navigation.salesAdvisor'}, {id :'deliveryDateFilter', display: 'MM/DD/YYYY'},
  {id:'deliveryTimeFilter', display: 'HH:MM' }, 
  {id:'statusFilter', display: 'opcodeServiceManagement.status'}];
  statusOptions = [{id: 'PENDING', display: 'deliveryChecklist.pending'}, {id: 'COMPLETED', display :'deliveryChecklist.completed' }, {id: 'SUBMITTED', display :'deliveryChecklist.submitted' }, {id: 'VEHICLE_RETURNED', display :'deliveryChecklist.vehicle_returned' }];
  searchForm: UntypedFormGroup;
  filterForm: UntypedFormGroup;
  subscriptions: SubscriptionList = {};
  allChecklistCount$: Observable<number>;
  totalCount$: Observable<number>;
  CURRENT_PAGE=1;
  PAGE_SIZE=20;
  pageIndex = 0;
  pageSizeOptions: number[] = [20, 50, 100]
  @ViewChild('scrollcontainer') scrollContainer:ElementRef;
  checklists$: Observable<IDigitalChecklistAppointment[]>;
  dataSource: any;
  checklists: IDigitalChecklistAppointment[];
  dealerCode$: Observable<string>;
  dealerCode: string;
  searchValues  = [];
  isSearchLoading = false;
  sortingField  = 'deliveryDate';
  sortOrder : string = SortOrder.DESC;
  allChecklists: IDigitalChecklistAppointment[];
  showSpinner = false;
  @ViewChild(CdkVirtualScrollViewport, { static: false })
  public viewPort: CdkVirtualScrollViewport;
  @ViewChild('dragHelper') dragHelper;
  @ViewChildren('tableHead') tableHeads;
  width=113;
  selectedColumn: any;
  dragged = false;
  private _currentDragger: any;
  private _selectedColumnElement: any;
  private _startWidth: number;
  private _startX: any;
  splitChar = 0;
  lockTable=true;
  paramsChecklistStatus='';
  isChecklistsSearch=false;
  cleanState=false;
  leftMenuCount=0;
  @Output() public onColumnChange: EventEmitter<any> = new EventEmitter();
  filtersVal:any;

  constructor(private readonly formBuilder: UntypedFormBuilder,
    private readonly deliveryChecklistState: Store<DeliveryChecklistState>,
    private readonly serviceAppointmentStore: Store<ServiceAppointmentState>,
    private readonly router: Router,
    private readonly dealerState: Store<DealerState>,
    public readonly dialog: MatDialog,
    private readonly deliveryChecklistService: DeliveryChecklistService,
    private readonly alertService: AlertService,
    private readonly copy: Clipboard,
    private readonly translate: TranslateService,
    private readonly cdref: ChangeDetectorRef,
    public activatedRoute: ActivatedRoute,
    private appSyncService: AppSyncService
  ) { }

  ngAfterViewChecked(): void {
    if(this.lockTable && this.tableHeads?._results.length)
    {
    const sessionTable=JSON.parse(getSessionTable('ChecklisSummaryTable'));
    sessionTable?.forEach(col => {
      const column=this.tableHeads._results.filter(c=>c.nativeElement.innerText===this.translate.instant(col.column))[0];
      if(col?.width && column)
      {
        column.nativeElement.style.width = `${col?.width}`;
        if(col.column ==='VIN')
        {
          this.width = parseInt(col?.width.slice(0,-2));
          this.splitChar = -(Math.round(this.width / 10) - 4);
          this.cdref.detectChanges();
        }
      }
    });
    this.lockTable=false;
    }
  }

  ngOnInit(): void {
    let path='';
    this.subscriptions.query = this.activatedRoute.url.subscribe(url => {
      path = url.map(segment => segment.path).join('/');
      if (path.includes('pending')) {
        this.paramsChecklistStatus = DigitalChecklistStatus.PENDING;
        this.statusOptions = this.statusOptions.filter(data => data.id === 'PENDING');
        this.hideColumns(['deliveryTime', 'deliveryTimeFilter']);
      } else if (path.includes('completed')) {
        this.hideColumns(['vehicleStatus', 'vehicleStatusFilter', 'deliveryTime', 'deliveryTimeFilter']);
        this.sortOrder = SortOrder.DESC;
        this.paramsChecklistStatus = DigitalChecklistStatus.COMPLETED;
        this.statusOptions = this.statusOptions.filter(data => data.id !== 'PENDING');
      }
      else{
        this.hideColumns(['deliveryTime', 'deliveryTimeFilter']);
        this.paramsChecklistStatus = "ALL";
      }
    });
    this.dealerCode$ = this.dealerState.select(selectDealerCode);
    this.subscriptions.dealerCode = this.dealerCode$.subscribe(code => {
      this.dealerCode = code;
    })
    this.isLoading$ = this.deliveryChecklistState.select(fromSelectors.selectChecklistSummaryLoading);
    this.subscriptions.notificationData = this.serviceAppointmentStore.select(selectNotificationDashboardData).subscribe((results: any) => {
      if(path.includes('completed'))
      {
        this.leftMenuCount= results.filter(key=>key.key==='completedDigitalChecklist')[0]?.value || 0;
      }
      else if(path.includes('pending'))
      {
        this.leftMenuCount= results.filter(key=>key.key==='pendingDigitalChecklist')[0]?.value || 0;
      }
    });


    this.setupStore(path);
    this.InitializeSearchForm();
  }

  hideColumns(columns) {
    this.initColumns=this.initColumns.filter(col=> !columns.includes(col.id));
    this.columnsToDisplay=this.columnsToDisplay.filter(col=>!columns.includes(col));
    this.columnsToDisplayForFilter=this.columnsToDisplayForFilter.filter(col=>!columns.includes(col));
    this.initColumnsForFilter=this.initColumnsForFilter.filter(col=>!columns.includes(col.id));
  }

  setupStore(path) {
    if (this.router.url.includes('search')) {
      this.filtersVal = history.state?.filters || {};
      const searchFilters = history.state?.filters;
      if (!searchFilters) {
        this.checklists = [];
      }
      else {
        searchFilters.sorts = [{
          prop: "dateOfAcquired",
          order: this.sortOrder
        }];
        this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus, pageNumber: this.CURRENT_PAGE, pageSize: this.PAGE_SIZE, appendData: false, filters: searchFilters }));
      }
    }
    else {
      const filters = { sorts: [] };
      filters.sorts = [{
        prop: "dateOfAcquired",
        order: this.sortOrder
      }];
      this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus,pageNumber:this.CURRENT_PAGE,pageSize:this.PAGE_SIZE,appendData:false, filters }));
    }
    this.subscribeSummary();
    this.subscriptions.vehicleData = this.checklists$.subscribe(data => {
      this.allChecklists = data;
      this.decorateChecklist(this.allChecklists);
      if(path.includes('completed')){
        this.subscriptions.appSyncServiceSubscription = this.appSyncService.subscribeAppSyncServer(this.dealerCode).subscribe((res) => {
          if(res?.data){
            const updatedArray = this.allChecklists?.map(obj => {
              if (obj.digichkId === res?.data?.digichkId) {
                return { ...obj, status: res?.data?.checklistStatus };
              }
              return obj;
            });
            if(updatedArray?.length){
              this.decorateChecklist(updatedArray);
            }
          }
        });
      }
    });
  }

  decorateChecklist(data) {
    this.checklists = data;
    this.dataSource = new MatTableDataSource(data);
    this.isSearchLoading = false;
  }

  InitializeSearchForm() {
    this.searchForm = this.formBuilder.group({
      customerNameFilter: [''],
      salesConsultantFilter:[''],
      contactInfoFilter: [''],
      modelFilter: [''],
      vehicleStatusFilter:[''],
      vinFilter: [''],
      deliveryDateFilter: [''],
      deliveryTimeFilter: [''],
      statusFilter: ['']
    })
  }

  get Status() {
    return DigitalChecklistStatus;
  }

  editAppointment(digiChecklist: IDigitalChecklistAppointment) {
    this.router.navigate(['asp/deliveryChecklist/createChecklist'], {
      queryParams: {
        id: digiChecklist.digichkId,
        email: digiChecklist.customer?.emailAddress,
      }
    });
  }

  cancelCheckListAppointment(event:any,digitalChecklist)
  {
    event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {
        popupTitle: 'teamManagement.deleteConfirmation',
        popupBodyText: 'deliveryChecklist.deleteChecklist',
        saveButton: 'service.yes',
        cancelButton: 'service.no'
      },
      panelClass: 'asp-modal-container'
    });
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        this.deliveryChecklistState.dispatch(
          new fromActions.CancelChecklist({ digitalChecklist }));
      }
    });
  }

  getDeliveryDate(date: string) {
    return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('MM/dd/yyyy');
  }

  searchChecklists() {
    const filters = this.getSearchFilters();
    if (!_.isEmpty(filters)) {
      filters.sorts = [{
        prop: "dateOfAcquired",
        order: this.sortOrder
      }];
      /*clean the existing data in the state*/
      this.cleanStateData();
      /* search should start from page 1 so reset the page */
      this.resetPage();
        this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus, pageNumber: this.CURRENT_PAGE, pageSize: this.PAGE_SIZE,appendData:false,filters}));
        this.subscribeSummary();
      this.isSearchLoading = true;
      this.subscriptions.vehicleData = this.checklists$.subscribe(data => {
        if(data && data.length)
        {
          this.allChecklists = data;
          this.checklists = data;
          this.dataSource = new MatTableDataSource(this.checklists);
        }
        else{
          this.dataSource = new MatTableDataSource([]);
        }
        this.isSearchLoading = false;
        this.cdref.detectChanges();
      });
    }
  }
  subscribeSummary() {
    this.allChecklistCount$ = this.deliveryChecklistState.select(fromSelectors.selectChecklistSummaryCount);
    this.totalCount$ = this.deliveryChecklistState.select(fromSelectors.selectSummaryTotalCount);
    this.checklists$ = this.deliveryChecklistState.select(fromSelectors.selectChecklistSummary);
  }

  getFilters() {
    return this.searchForm.value;
  }

  addSearchField(columnField, value) {
    const index = this.searchValues.findIndex(x => x?.column === columnField);
    if (index === -1 && !!value) {
      this.searchValues.push({ column: columnField, colValue: value });
    }
    else if (value) {
      this.searchValues[index].colValue = value;
    }
    else {
      this.searchValues.splice(index, 1);
    }
    if(!_.isEmpty(this.getSearchFilters()))
    {
      this.isChecklistsSearch=true;
    }
    this.searchChecklists();
  }

  onCloseFilterValue(searchColumn, index){
    this.searchValues.splice(index, 1);
    this.searchForm.get(searchColumn).patchValue('');
    const filters = this.getSearchFilters();
    if (_.isEmpty(filters)) {
      this.isChecklistsSearch=false;
      this.fetchOriginalData();
    }
    else {
      this.searchChecklists();
    }
  }

  clearFilters() {
    this.searchValues = [];
    this.InitializeSearchForm();
    this.isChecklistsSearch=false;
    this.fetchOriginalData();
  }

  fetchOriginalData() {
    /* Clean the existing data in the state*/
    this.cleanStateData();
    /* reset the page number*/
    this.resetPage();
    const filters = {sorts: []}
    filters.sorts = [{
      prop: "dateOfAcquired",
      order: this.sortOrder
    }];
    this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus, pageNumber: this.CURRENT_PAGE, pageSize: this.PAGE_SIZE ,appendData:false, filters}));
  }

  getSearchFilters() {
    const filterObj= _.pickBy(this.getFilters(), val => val !== undefined && val !== null && val !== '');
    Object.keys(filterObj).forEach(key => {
      filterObj[key] = filterObj[key].trim();
    });
    /* format date in yyyMMdd format if present*/
    if (filterObj?.deliveryDateFilter) {
      const [month, day, year] = filterObj.deliveryDateFilter.split('/');
      filterObj.deliveryDateFilter = `${year}-${_.padStart(month, 2, '0')}-${_.padStart(day, 2, '0')}`;
    }
    /* remove '+' from the phone number if provided*/
    if (filterObj?.contactInfoFilter && filterObj.contactInfoFilter[0]==='+') {
      filterObj.contactInfoFilter = filterObj.contactInfoFilter.slice(1);
    }
    return filterObj;
  }

  sortChange(col: string) {
    const columsToIgnore = ['vin', 'contactInfo', 'vehicleStatus', 'status', 'deliveryTime'];
    if (columsToIgnore.includes(col)) {
      return;
    }
    if (this.sortingField === col) {
      this.sortOrder = this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
    }
    else {
      this.sortOrder = SortOrder.ASC;
    }
    this.sortingField = col;
    /* *condition to sort checklist and ignore archived checklist */
    const filters = this.getSearchFilters();
    filters.sorts = this.getSortColumn(col);
    this.resetPage();
    this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus, pageNumber: this.CURRENT_PAGE, pageSize: this.PAGE_SIZE, appendData: false, filters }));
    this.subscribeSummary();
  }

   scrollDown() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop += 20;
  }

   scrollUp() {
    const filterList = document.querySelector('.filter-group');
    filterList.scrollTop -= 20;
  }

  createNewDeliveryChecklist() {
    this.router.navigate(['asp/deliveryChecklist/createChecklist'])
  }

  viewPrintPdf(element, print = false) {
    this.showSpinner = true;
    this.deliveryChecklistService.getPdfData(element.digichkId, element?.pathUrl ? element.pathUrl: '').subscribe((response: any) => {
      if (response) {
        this.showSpinner = false;
        const blobURL = this.generatePDF(response)
        if(print) {
          window.open(blobURL, '_blank').print();
        }
        else {
          window.open(blobURL, '_blank');
        }
      }
    }, _error => {
      this.showSpinner = false;
      this.alertService.showAlert('deliveryChecklist.pdfNotFound');
    });
  }

  resubmitChecklist(element) {
    this.deliveryChecklistState.dispatch(new fromActions.ResubmitDigiChekReq({ digitalChecklist: element}));
  }

  downloadPDF(element){
    this.showSpinner = true;
    this.checklists$ = this.deliveryChecklistState.select(fromSelectors.selectChecklistSummary)
    combineLatest([this.deliveryChecklistService.getPdfData(element.digichkId, element?.pathUrl ? element.pathUrl: ''),this.checklists$])
    .pipe(take(1))
    .subscribe(([response,checklistList]) => {
      if (response && checklistList) {
        const checklistData = checklistList.filter(d => d.digichkId === element.digichkId)
        let pdfName = "";
        if(checklistData.length){
          pdfName = this.createPDFName(checklistData[0])
        }else{
          pdfName = 'Checklist'
        }
        this.showSpinner = false;
        const blobURL = this.generatePDF(response)
        const anchorTag = document.createElement("a");
        anchorTag.setAttribute('style', 'display:none');
        anchorTag.setAttribute('href', blobURL);
        anchorTag.setAttribute('download', pdfName);
        document.body.appendChild(anchorTag);
        anchorTag.click();
        URL.revokeObjectURL(blobURL);
        document.body.removeChild(anchorTag);
      }
    }, _error => {
      this.showSpinner = false;
      this.alertService.showAlert('deliveryChecklist.pdfNotFound');
    });
  }

  createPDFName(data){
    const firstName = `${data?.customer?.firstName[0].toUpperCase()}${data?.customer?.firstName.substring(1)}`;
    const lastName = `${data?.customer?.lastName[0].toUpperCase()}${data?.customer?.lastName.substring(1)}`;
    return `${firstName} ${lastName}_${data?.vehicle?.model} ${data?.vehicle?.year}_Signed Delivery Checklist`; 
  }

  generatePDF(response){
    let pdfResponse = response.data;
        const updatedResponse = pdfResponse.split('base64,')[1];
        if (updatedResponse) {
          pdfResponse = updatedResponse;
        }
        const binaryString = window.atob(pdfResponse);
        const bytes = new Uint8Array(binaryString.length);
        const binaryToBlob = bytes.map((_byte, i) => binaryString.charCodeAt(i));
        const blob: Blob = new Blob([binaryToBlob], { type: 'application/pdf' });
        return (window.URL || window.webkitURL).createObjectURL(blob)
  }
 
  ngOnDestroy() {
    this.cleanStateData();
    unsubscribeSubscriptions(this.subscriptions);
  }

  onCopyDetails(vin: string){
    return this.copy.copy(vin);
  }

  public onDraggerClick(event) {
    this.dragHelper.nativeElement.style.display = 'none';
    event.stopPropagation();
  }

  public setHelperPosition(event) {
    const helper = this.dragHelper.nativeElement;
    helper.style.display = 'block';
    helper.style.left = `${event.x - helper.parentNode?.getBoundingClientRect().left}px`;
  }


  public toggleColumnWidth(col, event) {
    const selectedColumnForResize = this.initColumns.filter(c => c.display === col)[0];
    const selectedElement = event?.target?.parentNode;
    const elementWidth=parseInt((selectedElement?.style?.width || '0px').slice(0,-2));
    const width = (this.initColumns && (elementWidth >selectedColumnForResize?.minWidth)) ? selectedColumnForResize?.minWidth : selectedColumnForResize?.maxWidth;
    selectedElement.style.flex = `0 0 ${width}px`;
    selectedElement.style.width = `${width}px`;
    if (col === "VIN" || col === 'vin')
    {
      this.width = parseInt(width);
      this.splitChar = -(Math.round(this.width / 10) - 4);
    }
    this.selectedColumn = event?.target?.parentNode;
    this.dragged = false;
    this.onColumnChange.emit(null);
    const setting={column:col,width:`${width}px`};
    setSessionTable(setting,col,'ChecklisSummaryTable');
  }

  startResize(event, _column) {
    const col = event.source.element.nativeElement;
    this.setHelperPosition(event);
    this.dragged = true;
    this._currentDragger = col;
    this._selectedColumnElement = col.parentNode;
    this._startWidth = this._selectedColumnElement.offsetWidth;
    this.dragHelper.nativeElement.style.display = 'block';
    this._currentDragger.style.visibility = 'hidden';
    this._startX = this._currentDragger.getBoundingClientRect()['x'];
    this._selectedColumnElement.classList.add('dragged');
  }

  resizeColumn(event: any, col: any) {
    
    this.selectedColumn = event.source.element.nativeElement.parentNode;
    const selectedColumnForResize = this.initColumns.filter(c => c.display === col)[0];
    this.selectedColumn.style.maxWidth = `${selectedColumnForResize.maxWidth}px`;
    this.selectedColumn.style.minWidth = `${selectedColumnForResize.minWidth}px`;
    if (this.dragged) {
      const x = event.event.x ? event.event.x : event.pointerPosition.x ;
      const width = this._startWidth + (x - this._startX);
      if (width >= parseInt(this.selectedColumn.style.minWidth, 10) && width <= parseInt(this.selectedColumn.style.maxWidth, 10)) {
        this._selectedColumnElement.style.width = `${width}px`;
        this._selectedColumnElement.style.flex = `0 0 ${width}px`;
        this.setHelperPosition(event.event);
      }
    }
    this.setHelperPosition(event.event);
  }

  endResize(_event, col) {
    if (this.dragged) {
      this.dragged = false;
      this.selectedColumn.style['flex'] = this._selectedColumnElement?.style.flex;
      this.selectedColumn.style['width']  = this._selectedColumnElement?.style.width;
      this.selectedColumn.width = this._selectedColumnElement?.style.width;
      if (col === "VIN" || col === "vin") {
        this.width = (parseInt(this.selectedColumn.width))
        this.splitChar = -(Math.round(this.width / 10) - 4)
        this.width = (parseInt(this.selectedColumn.width))
      }
      this._selectedColumnElement?.classList.remove('dragged');
      this._selectedColumnElement = null;
      this._currentDragger.style.visibility = 'visible';
      this._currentDragger.style.transform = 'none';
      this._startX = this._startWidth = 0;
      this.onColumnChange.emit(null);
      this.initColumns.forEach(column => {
        if (column.display === col) {
          column.width = this.selectedColumn.width;
        }
      });
      const setting={column:col,width: this.selectedColumn.width};
      setSessionTable(setting,col,'ChecklisSummaryTable');
    }
    this.dragHelper.nativeElement.style.display = 'none';
  }

  sendEmailToCustomer($event, checklist, actionMenuTrigger?: MatMenuTrigger) {
    $event.stopPropagation();
    if (!checklist.customer?.emailAddress) {
      this.openEmailAddressDialog(checklist, actionMenuTrigger);
      return;
    }
    this.openSendEmailConfirmation(checklist, actionMenuTrigger);
  }

  openEmailAddressDialog(checklist, actionMenuTrigger?: MatMenuTrigger) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '520px',
      data: {
        key: 'email',
        popupTitle: 'deliveryChecklist.provideEmailAddress',
        popupBodyText: '',
        saveButton: 'teamManagement.ok',
        cancelButton: 'overrideCapacity.cancel'
      },
      panelClass: 'asp-modal-container'
    });

    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result?.action === 'confirm') {
        this.openSendEmailConfirmation(checklist, actionMenuTrigger, result?.data?.emailAddress);
        return;
      }
      this.reopenActionMenu(actionMenuTrigger);
    });
  }

  openSendEmailConfirmation(checklist, actionMenuTrigger?: MatMenuTrigger, emailAddress?: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        popupTitle: 'deliveryChecklist.sendEmailCustomer',
        popupBodyText: 'deliveryChecklist.sendPDFToCustomer',
        saveButton: 'service.yes',
        cancelButton: 'overrideCapacity.cancel'
      },
      panelClass: 'asp-modal-container'
    });
    this.subscriptions.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result?.action === 'confirm') {
        this.deliveryChecklistState.dispatch(
          new fromActions.SendEmail({ digitalChecklist: checklist, type: "SEND_CHECKLIST_PDF", emailAddress })
        );
        return;
      }
      this.reopenActionMenu(actionMenuTrigger);
    });
  }

  reopenActionMenu(actionMenuTrigger?: MatMenuTrigger) {
    if (!actionMenuTrigger) {
      return;
    }
    setTimeout(() => actionMenuTrigger.openMenu());
  }

  resetPage() {
    this.CURRENT_PAGE = 1;
    this.pageIndex = 0;
  }

  cleanStateData()
  {
    this.deliveryChecklistState.dispatch(new fromActions.CleanChecklistSummaryState({}));
  }

  onRecordsPerPageChange(value: number) {
    this.pageIndex = 0;
    this.PAGE_SIZE = value;
    this.OnLoadNextPageData();
  }

  onPageChange(pageEvent: PageEvent) {
    this.pageIndex = pageEvent.pageIndex;
    this.OnLoadNextPageData();
  }

  OnLoadNextPageData() {
    this.checklists = [];
    this.dataSource = new MatTableDataSource(this.checklists);
    this.isSearchLoading = true;
    this.CURRENT_PAGE = this.pageIndex + 1;
      const filters = this.filtersVal || {};
    if (!filters.sorts) {
      filters.sorts = this.getSortColumn(this.sortingField);
    }
    this.deliveryChecklistState.dispatch(new fromActions.LoadChecklistSummary({ checklistSummaryStatus: this.paramsChecklistStatus, pageNumber: this.CURRENT_PAGE, pageSize: this.PAGE_SIZE,appendData:false,filters }));
  }

  getSortColumn(field) {
    return [{
      prop: field,
      order: this.sortOrder
    }];
  }
}

